import { createPortal } from 'react-dom';
const DIALOG_ROOT_ID = 'dialog-container-root';
export function getDialogRoot() {
    const existing = document.getElementById(DIALOG_ROOT_ID);
    if (existing) return existing;
    const root = document.createElement('div');
    root.id = DIALOG_ROOT_ID;
    document.body.appendChild(root);
    return root;
}
export function DialogPortal({ children }) {
    return /*#__PURE__*/ createPortal(children, getDialogRoot());
}
